<dx-data-grid
  *ngIf="vehicleService"
  height="100%"
  width="auto"
  [dataSource]="vehicleService.fleetManagerComments"
  [remoteOperations]="false"
  (onRowInserting)="onCommentInserting($event)"
  (onRowUpdating)="onCommentUpdating($event)"
  (onRowRemoving)="onCommentRemoving($event)">
  <!-- Settings -->
  <dxo-editing mode="row" [allowAdding]="true" [allowDeleting]="true" [allowUpdating]="true"> </dxo-editing>
  <dxo-editing [allowAdding]="true" [allowDeleting]="true" [allowUpdating]="true"></dxo-editing>
  <dxo-export [enabled]="true" fileName="comments-export"></dxo-export>

  <!-- Columns -->
  <dxi-column caption="Comment" dataField="comment" dataType="string" [allowEditing]="true"> </dxi-column>
  <dxi-column
    caption="Saved At"
    dataField="updatedAt"
    dataType="date"
    format="shortDateShortTime"
    [allowEditing]="false"></dxi-column>
  <!-- Templates -->
</dx-data-grid>
